document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeModule_CartNote', () => {
    return {
      updating: false,
      init() {
        const noteValue = this.$root.value;
        this.$root.value = noteValue.replace(/【贈り主名】.*?【\/贈り主名】\s*/gs, '').trim();
      },
      updateNote() {
        this.updating = true;
        const noteValue = this.$root.value;
        fetch(theme.routes.cart_update_url, {
          method: 'POST',
          body: JSON.stringify({ note: noteValue }),
          credentials: 'same-origin',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json;',
            Accept: 'application/json',
          },
        }).then(() => {
          this.updating = false;
        });
      },
    };
  });
});

// SNSギフトアプリの贈り主名フィールド（data-testid="gift-nickname"）への入力を
// Shopifyカートノートに【贈り主名】として保存する
(function () {
  let nicknameInput = null;
  let saveTimeout = null;

  function saveToCartNote(name) {
    const noteTextarea = document.getElementById('CartSpecialInstructions');
    let currentNote = noteTextarea ? noteTextarea.value : '';
    currentNote = currentNote.replace(/【贈り主名】.*?【\/贈り主名】\s*/gs, '').trim();

    if (name) {
      currentNote = `【贈り主名】${name}【/贈り主名】` + (currentNote ? '\n\n' + currentNote : '');
    }

    fetch(theme.routes.cart_update_url, {
      method: 'POST',
      body: JSON.stringify({ note: currentNote }),
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json;',
        Accept: 'application/json',
      },
    });
  }

  function attachToNicknameInput(input) {
    if (nicknameInput === input) return;
    nicknameInput = input;

    input.addEventListener('input', () => {
      clearTimeout(saveTimeout);
      saveTimeout = setTimeout(() => {
        saveToCartNote(input.value.trim());
      }, 800);
    });

    input.addEventListener('blur', () => {
      clearTimeout(saveTimeout);
      saveToCartNote(input.value.trim());
    });
  }

  function checkForNicknameInput() {
    const input = document.querySelector('input[data-testid="gift-nickname"]');
    if (input) {
      attachToNicknameInput(input);
    } else if (nicknameInput) {
      // eギフトから離れた → 贈り主名をカートノートから削除
      nicknameInput = null;
      saveToCartNote('');
    }
  }

  const observer = new MutationObserver(checkForNicknameInput);
  observer.observe(document.body, { childList: true, subtree: true });
  checkForNicknameInput();
})();
